import authHeader from "../helpers/authHeader";
//import history from "../helpers/history";
import userService from "./userService";

const getUsers = async () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/ApplicationUser/GetAllUsersWithId`,
    requestOptions
  )
    .then(handleResponse)
    .then((users) => {
      return users;
    });
};

const getUsersWithNoAppt = async () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/ApplicationUser/GetAllUsersWithIdNoAppt`,
    requestOptions
  )
    .then(handleResponse)
    .then((users) => {
      return users;
    });
};

const updatePersonalInfo = async (personalInfo) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(personalInfo),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/ApplicationUser/UpdateUserInfoStaff`,
    requestOptions
  )
    .then(handleResponse)
    .then((userInfo) => {
      return userInfo;
    });
};

const updateAttorneyInfo = async (personalInfo) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(personalInfo),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/ApplicationUser/UpdateAttorneyInfoStaff`,
    requestOptions
  )
    .then(handleResponse)
    .then((userInfo) => {
      return userInfo;
    });
};

const resetPasswordRequest = (resetRequest) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(resetRequest),
  };
  //console.log("login request");
  return fetch(
    `${process.env.REACT_APP_API_URL}/AuthenticateLitigant/RequestResetPassword`,
    requestOptions
  );
};

const register = (dob, firstName, lastName, email, phoneNumber) => {
  //console.log(dob, firstName, lastName, email, password, confirmPassword);
  return fetch(
    `${process.env.REACT_APP_API_URL}/AuthenticateLitigant/RegisterStaff`,
    {
      credentials: "include",
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeader() },
      body: JSON.stringify({
        dob,
        firstName,
        lastName,
        email,
        phoneNumber,
      }),
    }
  )
    .then(handleResponse)
    .then((user) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      //sessionStorage.setItem("user", JSON.stringify(user));
      return;
    });
};

const registerAttorney = (
  dob,
  firstName,
  lastName,
  email,
  phoneNumber,
  barNumber
) => {
  //console.log(dob, firstName, lastName, email, password, confirmPassword);
  return fetch(
    `${process.env.REACT_APP_API_URL}/AttorneyRegistration/RegisterAttorneyStaff`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeader() },
      body: JSON.stringify({
        dob,
        firstName,
        lastName,
        email,
        phoneNumber,
        barNumber,
      }),
    }
  )
    .then(handleResponse)
    .then((user) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      //sessionStorage.setItem("user", JSON.stringify(user));
      return;
    });
};

const getNotifications = async () => {
  const requestOptions = {
    credentials: "include",
    method: "GET",
    headers: authHeader(),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/StaffNotification/GetNewStaffNotifications`,
    requestOptions
  )
    .then(handleResponse)
    .then((notifications) => {
      //console.log(notifications);
      return notifications;
    });
};

const clearNotification = async (id) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ id: id }),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/StaffNotification/ClearNotification`,
    requestOptions
  )
    .then(handleResponse)
    .then((payload) => {
      return payload;
    });
};

const getAttorneyRegistrations = async () => {
  const requestOptions = {
    credentials: "include",
    method: "GET",
    headers: authHeader(),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/AttorneyRegistration/GetNewAttorneyRegistrations`,
    requestOptions
  )
    .then(handleResponse)
    .then((notifications) => {
      //console.log(notifications);
      return notifications;
    });
};

const checkEmail = async (email) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ id: email }),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/AttorneyRegistration/CheckEmail`,
    requestOptions
  )
    .then(handleResponse)
    .then((payload) => {
      return payload;
    });
};

const approveAttorney = async (id) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ id: id }),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/AttorneyRegistration/ApproveAttorneyRegistration`,
    requestOptions
  )
    .then(handleResponse)
    .then((payload) => {
      return payload;
    });
};

const denyAttorney = async (id) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ id: id }),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/AttorneyRegistration/DenyAttorneyRegistration`,
    requestOptions
  )
    .then(handleResponse)
    .then((payload) => {
      return payload;
    });
};

const getAttorneys = async () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/ApplicationUser/GetAllAttorneysWithId`,
    requestOptions
  )
    .then(handleResponse)
    .then((users) => {
      return users;
    });
};

const getAllQuestionnaires = async (id) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ id: id }),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/UserQuestionnaire/GetAllUserQuestionnaires`,
    requestOptions
  )
    .then(handleResponse)
    .then((payload) => {
      return payload;
    });
};

const getScheduledAppointmentsByDate = async (date) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/GetScheduledAppointmentsByDate?date=${date}`,
    requestOptions
  )
    .then(handleResponse)
    .then((payload) => {
      return payload;
    });
};

const handleResponse = (response) => {
  //console.log(response);
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      //console.log(response);
      if (response.status === 401 || response.status === 403) {
        // auto logout if 401 response returned from api
        userService.logout();
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
};

const staffService = {
  getUsers,
  updatePersonalInfo,
  updateAttorneyInfo,
  resetPasswordRequest,
  register,
  getNotifications,
  clearNotification,
  getAttorneyRegistrations,
  denyAttorney,
  approveAttorney,
  getAttorneys,
  registerAttorney,
  getAllQuestionnaires,
  checkEmail,
  getUsersWithNoAppt,
  getScheduledAppointmentsByDate,
};

export default staffService;
